export function fetch(idDivision) { return { type: 'CUSTOM_GROUPS/FETCH', idDivision } }
export function set(customGroups) { return { type: 'CUSTOM_GROUPS/SET', customGroups } }